import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NgChartsModule } from 'ng2-charts';

import { IconComponent } from '@shared/components/icon/icon.component';
import { TooltipDirective } from '@shared/directives/tooltip.directive';

import {
  TIRSChartLabel,
  TIRSChartType,
  TrialInsightsRemainingSpendChartService,
} from './remaining-spend-over-time-chart.service';
import { TrialInsightsRemainingSpendQueryService } from './remaining-spend-over-time-query.service';
import { TrialInsightsRemainingSpendStoreService } from './remaining-spend-over-time-store.service';
import { TrialInsightsRemainingSpendTableService } from './remaining-spend-over-time-table.service';
import { GenericTrialInsightsComponent } from '../../classes/trial-insights-component.class';
import { TrialInsightsHeaderComponent } from '../trial-insights-header/trial-insights-header.component';
import { TrialInsightsLegendComponent } from '../trial-insights-legend/trial-insights-legend.component';
import { TrialInsightsTableComponent } from '../trial-insights-table/trial-insights-table.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    TrialInsightsHeaderComponent,
    IconComponent,
    TooltipDirective,
    NgChartsModule,
    TrialInsightsLegendComponent,
    TrialInsightsTableComponent,
  ],
  selector: 'aux-trial-insights-finance-remaining-spend-over-time',
  styleUrls: [
    '../../trial-insights.component.scss',
    './trial-insights-finance-remaining-spend-over-time.component.scss',
  ],
  templateUrl: './trial-insights-finance-remaining-spend-over-time.component.html',
})
export class TrialInsightsFinanceRemainingSpendOverTimeComponent extends GenericTrialInsightsComponent<
  TIRSChartType,
  TIRSChartLabel
> {
  storeService = inject(TrialInsightsRemainingSpendStoreService);

  cdr: ChangeDetectorRef;
  chartService: TrialInsightsRemainingSpendChartService;
  queryService: TrialInsightsRemainingSpendQueryService;
  tableService: TrialInsightsRemainingSpendTableService;

  constructor() {
    const chartService = inject(TrialInsightsRemainingSpendChartService);
    const tableService = inject(TrialInsightsRemainingSpendTableService);
    const queryService = inject(TrialInsightsRemainingSpendQueryService);
    const cdr = inject(ChangeDetectorRef);

    super({
      cdr,
      chartService,
      color: '#094673',
      queryService,
      tableService,
      title: 'Remaining Spend',
    });

    this.chartService = chartService;
    this.tableService = tableService;
    this.queryService = queryService;
    this.cdr = cdr;
  }

  subscribeToData = () => {
    this.storeService.getRemainingSpend$().pipe(takeUntilDestroyed(this.destroyRef)).subscribe();
    this.queryService
      .processRemainingSpend$()
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe();
  };
}
